
export const ClassNames = (
    block: string,
    elt: string,
    ...modifiers: any[]
) => {
    const base = `${block}${elt ? `__${elt}` : ''}`;
    return `${base}${modifiers.filter(m => !!m).map(m => ` ${base}--${m}`).join('')}`;
}



// WEBPACK FOOTER //
// ./src/_helpers/ClassNames.ts